// extracted by mini-css-extract-plugin
export default {"main_title":"MainTitle_main_title__7jkpk","line":"MainTitle_line__sXQ43","astafiev":"MainTitle_astafiev__mq8WL"};